module.exports = __webpack_public_path__ + "static/media/dedieu.fc56390f.mp3";